import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Link, { ILink } from 'tbk-components/src/components/Button';

export interface ICareer {
	link?: ILink;
	text?: string;
}

export interface ICareersProps extends IBaseElementProps {
	careers?: ICareer[];
	learnMoreLabel?: string;
}

/**
 * Careers
 * @block
 * @requiresHooks
 * @icon groups
 */
const Careers: React.FC<ICareersProps> = ({
	className,
	classNames = [],
	careers = [],
	learnMoreLabel = 'Learn More',
}) => (
	<div className={className || cn('careers', ...classNames)}>
		{careers.map(({ link, text }, index) => (
			<div key={index} className="career">
				<h2 className="career__heading">
					<Link {...link} className="career__heading__link" />
				</h2>

				<div className="career__text">{text}</div>

				<Link
					href={link.href}
					label={learnMoreLabel}
					className="career__read-more"
				/>
			</div>
		))}
	</div>
);

export default Careers;
